module.exports = __webpack_public_path__ + "img/bg-title5.d21159d1.png";